import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 45px;
  box-shadow: 0px 10px 60px 0px rgb(0 0 0 / 10%),
    0px 0px 0px 1px rgb(0 0 0 / 1%);
  border-top: solid 3px #185335;

  .container-feedback {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 20px 0;
  }

  .container-title {
    font-weight: bold;
    color: #185335;
    text-align: center;
    line-height: 1;
    margin: 30px 0 0 0;

    &::after {
      display: block;
      content: '';
      width: 160px;
      height: 1px;
      background-color: #185335;
      margin-top: 30px;
      margin-bottom: 15px;
      margin-left: auto;
      margin-right: auto;
    }
  }

  .posts {
    padding: 15px;

    &__button {
      display: inline-block;
      outline: none;
      border-radius: 6px;
      padding: 6px 10px;
      color: #fff;
      background-color: #185335;
      border: solid 1px #185335;

      &:hover {
        background-color: #12482d;
        border: solid 1px #12482d;
      }
    }

    @media screen and (min-width: 992px) {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
    }

    &__item {
      margin: 15px;

      @media screen and (min-width: 992px) {
        flex: 0 0 22%;
      }
    }
  }
`;
